// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Work+Sans:wght@500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.event-details-page {
  padding: 16px 0 24px;
}

.details-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.08);
  padding: 18px;
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.event-layout {
  display: grid;
  gap: 20px;
}

.event-media {
  max-width: 520px;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.event-media .event-image {
  border: none;
  box-shadow: none;
  border-radius: 0;
}

.event-main {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.title {
  margin: 0;
  font-size: 24px;
  font-family: "Work Sans", Arial, sans-serif;
}

.meta-list {
  display: grid;
  gap: 12px;
}

.meta-row {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 10px;
  align-items: flex-start;
  padding: 10px 12px;
  background: #f7f8fb;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.meta-row fa-icon {
  color: var(--e-global-color-primary);
  margin-top: 2px;
}

.label {
  font-size: 12px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6c757d;
}

.value {
  font-weight: 600;
  color: #1f2937;
}

.directions-link {
  color: var(--e-global-color-primary);
  font-weight: var(--e-global-font-weight-semibold);
  text-decoration: underline;
}

.time-range {
  color: #4a5568;
}

.description-card {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
}

.cta-row {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: flex-end;
  margin-top: auto;
}

.cta-row .app-button {
  padding: 10px 18px;
  border-radius: 10px;
  font-weight: 600;
}

@media (min-width: 992px) {
  .event-layout {
    grid-template-columns: minmax(360px, 420px) 1fr;
    align-items: start;
  }
}`, "",{"version":3,"sources":["webpack://./projects/public/src/app/components/event-details/event-details.component.scss"],"names":[],"mappings":"AAEA;EACE,oBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,mBAAA;EACA,2CAAA;EACA,aAAA;EACA,qCAAA;AAAF;;AAGA;EACE,aAAA;EACA,SAAA;AAAF;;AAGA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2CAAA;AAAF;;AAGA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAAF;;AAGA;EACE,SAAA;EACA,eAAA;EACA,2CAAA;AAAF;;AAGA;EACE,aAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,+BAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;AAAF;;AAGA;EACE,oCAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,oCAAA;EACA,iDAAA;EACA,0BAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;AAAF;;AAGA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;AAAF;;AAGA;EACE;IACE,+CAAA;IACA,kBAAA;EAAF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Work+Sans:wght@500;600&display=swap');\n\n.event-details-page {\n  padding: 16px 0 24px;\n}\n\n.details-card {\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.08);\n  padding: 18px;\n  border: 1px solid rgba(0, 0, 0, 0.04);\n}\n\n.event-layout {\n  display: grid;\n  gap: 20px;\n}\n\n.event-media {\n  max-width: 520px;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n}\n\n.event-media .event-image {\n  border: none;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n.event-main {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.title-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.title {\n  margin: 0;\n  font-size: 24px;\n  font-family: 'Work Sans', Arial, sans-serif;\n}\n\n.meta-list {\n  display: grid;\n  gap: 12px;\n}\n\n.meta-row {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 10px;\n  align-items: flex-start;\n  padding: 10px 12px;\n  background: #f7f8fb;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.04);\n}\n\n.meta-row fa-icon {\n  color: var(--e-global-color-primary);\n  margin-top: 2px;\n}\n\n.label {\n  font-size: 12px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #6c757d;\n}\n\n.value {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.directions-link {\n  color: var(--e-global-color-primary);\n  font-weight: var(--e-global-font-weight-semibold);\n  text-decoration: underline;\n}\n\n.time-range {\n  color: #4a5568;\n}\n\n.description-card {\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);\n}\n\n.cta-row {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: auto;\n}\n\n.cta-row .app-button {\n  padding: 10px 18px;\n  border-radius: 10px;\n  font-weight: 600;\n}\n\n@media (min-width: 992px) {\n  .event-layout {\n    grid-template-columns: minmax(360px, 420px) 1fr;\n    align-items: start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
